












































































































































import { defineComponent, ref, toRefs, PropType, computed, watch, onMounted } from '@vue/composition-api';
import { getPosterUrlFromCreativeForm, logger } from '@tt4b/ttam-utils';
import {
  AdType,
  CreateMode,
  NormalCreative,
  AdgroupFormData,
  CampaignFormData,
  FullNormalFormData,
  NATIVE_AD_ACTION_TYPE,
  CreativeContext,
  isBOE,
  IDENTITY_TYPE_MAP,
  IdentityInfo,
} from '@tt4b/ttam-enums';
import {
  useCreativeIs,
  useStdCreativeIs,
  useStdProductSales,
  useCreativeMaterialValidate,
  useCreativeCatalogVpkgValidate,
  useCreativeActionTypeIs,
  useStdAdgroupIs,
} from '@tt4b/ttam-hooks';

import videoEmptyPng from '@tt4b/ttam-assets/src/images/creative/video-empty.png';
import singleVideoEmptyPng from '@tt4b/ttam-assets/src/images/creative/single-video-empty.png';
import MaterialSelect from './index';
import TtamMaterialDarkPost from './dark-post/index.vue';
import { useGetPreviewProductsByFormData, useGetVideoPackageByFormData } from '../../catalogs-preview/hook';
import ALink from '@/components/common/a-link/a-link.vue';
import { getPermissionLink } from '../utils/index';
import { useTikTokIdentityDisplayProps } from './../../identity/hooks';
const name = 'ttam-material-select-compose';

export default defineComponent({
  name,
  components: {
    TtamMaterialDarkPost,
    TtamMaterialSelect: MaterialSelect.TtamMaterialSelect,
    TtamMaterialModuleTitle: MaterialSelect.TtamMaterialModuleTitle,
    ttamMaterialEcho: MaterialSelect.TtamMaterialEcho,
    TtamMaterialCatalogVpkgSelect: MaterialSelect.TtamMaterialCatalogVpkgSelect,
    TtamMaterialSelectUploadProgress: MaterialSelect.TtamMaterialSelectUploadProgress,
    ALink,
  },
  props: {
    /** 上传进度 */
    count: { type: Number, default: 0 },
    progress: { type: Number, default: 0 },
    isUploading: { type: Boolean, default: true },
    isUploadFail: { type: Boolean, default: true },
    isSingleVideo: { type: Boolean, default: true },
    isSingleImage: { type: Boolean, default: false },
    isCatalogVideo: { type: Boolean, default: false },
    createMode: { type: String, default: CreateMode.CREATE },
    suggestionList: { type: Array, default: () => [] },
    currentAdType: { type: Number as PropType<AdType>, default: undefined },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData>,
      default: () => ({} as FullNormalFormData),
    },
    normalCreativeData: {
      type: Object as PropType<NormalCreative>,
      default: () => ({}),
    },
    uploadCreativeContext: {
      type: Object as PropType<CreativeContext>,
      default: () => ({}),
    },
    catalogId: { type: String, default: '' },
    bcId: { type: String, default: '' },
    templateId: { type: String, default: '' },
    // 错误字段map，初始化后的报错信息
    errorsMap: {
      type: Object as PropType<Record<string, string>>,
      default: () => ({}),
    },
    bindTtbaAccountData: {
      type: Object as PropType<Partial<IdentityInfo>>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const materialSelectNode = ref();

    const {
      isCatalogVideo,
      createMode,
      currentAdType,
      campaignData,
      adgroupData,
      creativeData,
      normalCreativeData,
      isSingleImage,
      uploadCreativeContext,
      isUploading,
      isUploadFail,
      bindTtbaAccountData,
    } = toRefs(props);
    const {
      isNative,
      isSupportUsePullVideo,
      isSupportUseTTBAPushVideo,
      isShowDarkPost,
      isDisabledDarkPostStatus,
      isSupportUseBCAuthPushVideo,
    } = useCreativeIs({
      createMode,
      campaignFormData: campaignData,
      adgroupFormData: adgroupData,
      normalCreativeData,
    });

    const isSupportChangeCover = computed(() => {
      const { PULL_TT_POST, REAL_TIME_LIVE } = NATIVE_AD_ACTION_TYPE;
      const { nativeAdActionType } = props.creativeData;
      if (isSingleImage.value) {
        return false;
      }
      return !nativeAdActionType || ![PULL_TT_POST, REAL_TIME_LIVE].includes(nativeAdActionType);
    });

    const { isSmartCreative, isTmpSingleVideo, isTmpCatalogsVideo } = useStdCreativeIs({
      campaignFormData: campaignData,
      adgroupFormData: adgroupData,
      creativeFormData: creativeData,
    });

    const { isCreate, isEdit, isCopy } = useCreativeActionTypeIs({ createMode, adgroupFormData: adgroupData });
    const { title } = MaterialSelect.usePropsTitle({ isNativePullPost: ref(false), currentAdType, isSmartCreative });
    const { isShopSource, isLivePromotion } = useStdProductSales({ adgroupFormData: adgroupData });

    const isVideo = computed(() => Boolean(creativeData.value.videoInfo?.vid));

    const isHasMaterial = computed(() => {
      const { videoInfo, imageInfo } = creativeData.value;
      return Boolean(videoInfo?.vid) || Boolean(imageInfo?.length);
    });

    const materialInfo = computed(() => {
      const { videoInfo = {}, imageInfo } = creativeData.value;
      const imageMaterial: any = imageInfo?.[0] ?? {};

      if (isSingleImage.value) {
        const { width, height, url } = imageMaterial;
        const materialName = imageMaterial?.name ?? videoInfo.name;
        const fileName = imageMaterial?.fileName ?? videoInfo.fileName;

        return {
          name: materialName || fileName,
          width,
          height,
          imageUrl: getPosterUrlFromCreativeForm(creativeData.value) ?? url,
        };
      } else {
        const { name: videoName, fileName, width, height, duration } = videoInfo;

        return {
          name: videoName || fileName,
          width,
          height,
          duration,
          imageUrl: getPosterUrlFromCreativeForm(creativeData.value),
        };
      }
    });
    const curIdentity = computed(() => ({
      identityId: creativeData.value.identityId as string,
      identityTtsShopId: creativeData.value.identityTtsShopId as string,
      identityType: creativeData.value.identityType as number,
      identityBcId: creativeData.value.identityBcId as string,
    }));

    const { canUseVideoList, canManageVideo } = useTikTokIdentityDisplayProps({
      identityInfo: curIdentity,
    });
    // 是否有推视频权限
    const isIdentityHasPushVideoRight = computed(() => {
      const { identityType, identityId } = creativeData.value || {};
      if (![IDENTITY_TYPE_MAP.BC_AUTH_TT, IDENTITY_TYPE_MAP.TT_USER].includes(identityType as number)) {
        return false;
      }
      logger.info('material select identity info', creativeData.value.identityData);
      if (identityId === bindTtbaAccountData.value?.identityId) {
        return bindTtbaAccountData.value?.canManageVideo;
      }
      return Boolean(canManageVideo.value ?? true);
    });
    const { isPostButtonDisabled, isCatalogVideoSelectVisible, isPushVideoButtonDisabled } =
      MaterialSelect.usePropsMaterialSelectControl({
        isSmartOn: isSmartCreative,
        isShop: isShopSource,
        isLive: isLivePromotion,
        isIdentityHasPushVideoRight,
        isCatalogVideo,
        creativeData,
      });

    const vpkgSelectIdProps = computed(() => ({
      catalogId: adgroupData.value.productPlatformId,
      bcId: adgroupData.value.catalogAuthorizedBc,
      templateId: creativeData.value.videoTplName,
      pSetId: creativeData.value.productSetId,
      productIds: creativeData.value.dpaProducts,
    }));

    const { previewProductList } = useGetPreviewProductsByFormData({
      adgroupData,
      creativeData,
    });

    const { videoPackages } = useGetVideoPackageByFormData({
      adgroupData,
    });

    const { vpkgValidator } = useCreativeCatalogVpkgValidate({ previewProductList, videoPackages });
    const { materialValidator } = useCreativeMaterialValidate({
      isEdit,
      isSingleImage,
      campaignFormData: campaignData as any,
      adgroupFormData: adgroupData as any,
    });

    const validator = computed(() => {
      if (isSmartCreative.value) {
        return materialValidator.value;
      } else {
        if (isCatalogVideoSelectVisible.value) {
          return vpkgValidator.value;
        }

        return materialValidator.value;
      }
    });

    const darkPostStatus = computed({
      get() {
        return creativeData.value.darkPostStatus;
      },
      set(val) {
        emit('dark-post-status-change', val);
      },
    });

    // 没有tiktok post权限显示提示
    const { isProductSales, isStandardAdsWithShop, isStandardAdsWithCatalog, isStandardAdsWithShowcase } =
      useStdAdgroupIs({
        adgroupFormData: adgroupData,
        campaignFormData: campaignData,
      });
    const showNoPermissionIdentityPost = computed(
      () =>
        isProductSales.value &&
        (isStandardAdsWithShop.value || isStandardAdsWithCatalog.value || isStandardAdsWithShowcase.value) &&
        (isCreate.value || isCopy.value) &&
        !isHasMaterial.value &&
        isSupportUsePullVideo.value &&
        canUseVideoList.value === false,
    );
    // 获取权限的url
    const noPermissionIdentityPostHelpLink = computed(() => {
      if (!showNoPermissionIdentityPost.value) {
        return;
      }
      return getPermissionLink({
        type: creativeData.value.identityType,
        bcId: creativeData.value.identityBcId,
      });
    });

    const isShowUploadProgress = computed(() => {
      // 首先要是 uploading 或者 uploadFail 才展示 progress
      if (!(isUploading.value || isUploadFail.value)) {
        return false;
      }
      const uploadUuid = uploadCreativeContext.value.creativeUuid;
      const currentUuid = normalCreativeData.value.creativeUuid;
      // 判断是否是当前创意，只有当前创意才展示进度条（因为有可能 upload 的时候切换 ad)
      return uploadUuid === currentUuid;
    });
    // 跳转BC获取推视频的权限
    const getBCPushVideoPermission = () => {
      const url = isBOE ? 'https://boei18n-business.byteoversea.net' : 'https://business.tiktok.com';
      const link = `${url}/manage/tiktok?org_id=${creativeData.value.identityBcId}`;
      window.open(link, '_blank');
    };
    return {
      materialSelectNode,
      AdType,
      isVideo,
      isNative,
      isHasMaterial,
      isSmartCreative,
      isTmpSingleVideo,
      isTmpCatalogsVideo,
      isPostButtonDisabled,
      isPushVideoButtonDisabled,
      isSupportChangeCover,
      isSupportUsePullVideo,
      isSupportUseTTBAPushVideo,
      isCatalogVideoSelectVisible,
      isShowDarkPost,
      isDisabledDarkPostStatus,

      title,
      materialInfo,
      videoEmptyPng,
      singleVideoEmptyPng,
      materialValidator,
      validator,
      darkPostStatus,

      vpkgSelectIdProps,
      isCreate,

      showNoPermissionIdentityPost,
      noPermissionIdentityPostHelpLink,
      name,
      isShowUploadProgress,
      isSupportUseBCAuthPushVideo,
      getBCPushVideoPermission,
      isIdentityHasPushVideoRight,
    };
  },
});
